import { connect, Dispatch } from 'react-redux';

import { HeaderComponent, HeaderComponentProperties } from './header.component';
import { AppState } from '../..';
import { timerReset, stopMocking } from '../../auth/auth.actions';
import { getProfile } from '../../profile/profile.actions';

interface ParentProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: ParentProps): Partial<HeaderComponentProperties> {
  return {
    timerExpired: state.auth.isTimerExpired,
    time: state.auth.time,
    modalProps: state.common.modalProps,
    showModal: state.common.showModal,
    showDialog: state.common.showDialog,
    profile: state.auth.currentProfile,
    isLoggedIn: state.auth.isLoggedIn,
    isSidebarOpen: ownProps.isSidebarOpen
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: ParentProps): Partial<HeaderComponentProperties> {
  return {
    onResetClick: () => {
      dispatch(timerReset());
    },
    getProfile: () => dispatch(getProfile()),
    stopMocking: () => dispatch(stopMocking())
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/header/_components/header.container.ts